<!-- COOKIE CONSENT BAR -->
<div class="bottom-bar d-flex align-items-center flex-wrap justify-content-between p-3" *ngIf="isBarShown" [@slideInOut]>
  <div><fa-icon class="fs-4 me-3" [icon]="faCookieBite"></fa-icon>This website uses cookies to ensure you get the best experience on our website.</div>
  <div class="d-flex flex-grow-1 flex-wrap justify-content-end">
    <button class="btn btn-link mb-1" (click)="onClickOpenDialog()">Manage Preferences</button>
    <button class="btn btn-warning ms-3" (click)="onClickAcceptAll()">Accept All</button>
  </div>
</div>
